import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'date',
    standalone: false
})
export class DatePipe implements PipeTransform {
    transform(value: unknown): string {
        const rawCampaign = value as any;
        const rawDate = `${rawCampaign?.date || rawCampaign?.created_at || rawCampaign?.updated_at || rawCampaign?.meta?.date || ''}`.trim();

        if (!rawDate) {
            return 'N/A';
        }

        const normalized = rawDate.includes('T') ? rawDate : rawDate.replace(' ', 'T');
        const parsed = new Date(normalized);

        if (Number.isNaN(parsed.getTime())) {
            return rawDate;
        }

        return new Intl.DateTimeFormat(undefined, {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        }).format(parsed);
    }
}